import JSAItem from "src/components/workLogs/formTemplates/jsa";
//--------------------------------------------------------------------------------------------
export default function JobSafetyAnalysis({
    setWorkLogs,
    setWorkInstructions,
    closeIt, 
     /*---- workInstruction-----------------------------------------*/
    workInstructionHashKey, 
    location, 
    jobSafetyAnalysisContent, 
    /*---- workLog ------------------------------------------------*/
    workLogHashKey, 
    projectName, 
    nearestMedicalFacility, 
    laborCategory, // main only
    userName, // main only
    /*---- admin -------------------------------------------------*/
    adminLink,
}){
    return(
        <JSAItem
            formTitle = {"JOB SAFETY ANALYSIS"}
            jobSafetyAnalysisContent = {JSON.parse(jobSafetyAnalysisContent || "{}")}
            setWorkLogs = {setWorkLogs}
            setWorkInstructions = {setWorkInstructions}
            closeIt = {closeIt}
            /*---- workInstruction ---------------------------------------*/
            workInstructionHashKey = {workInstructionHashKey}
            location = {location}
            /*---- workLog -----------------------------------------------*/
            workLogHashKey = {workLogHashKey}
            projectName = {projectName}
            nearestMedicalFacility = {nearestMedicalFacility}
            /*---- admin -------------------------------------------------*/
            adminLink = {adminLink}
            /*------------------------------------------------------------*/
            /*---- unique ------------------------------------------------*/
            userName = {userName}
            laborCategory = {laborCategory}
        />
    )
}